import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTargeting } from 'redux/modules/ads';
import * as styles from './AdDetails.scss';
var AdDetailTargeting = (_dec = connect(function (state, ownProps) {
  return {
    organization: state.organization.current,
    targetingInfo: state.ads.targetingInfo,
    theme: state.theme
  };
}, {
  getTargeting: getTargeting
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdDetailTargeting, _Component);

  var _super = _createSuper(AdDetailTargeting);

  function AdDetailTargeting(props) {
    _classCallCheck(this, AdDetailTargeting);

    return _super.call(this, props);
  }
  /** *********************************************************
   LIFECYCLE METHODS
   ***********************************************************/


  _createClass(AdDetailTargeting, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTargeting(this.props.organization.id, this.props.adDetails.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adDetails = _this$props.adDetails,
          targetingInfo = _this$props.targetingInfo;
      var targeting = targetingInfo ? targetingInfo.map(function (item, index) {
        var lastItem = index === targetingInfo.length - 1;
        var children = item.children.map(function (child, childIndex) {
          return /*#__PURE__*/React.createElement("li", {
            className: styles.targetingListItem,
            key: childIndex
          }, child);
        });
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: styles.targetingItem,
          style: lastItem ? {
            borderBottom: 'none'
          } : {}
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.targetingHeader,
          style: {
            textAlign: 'right'
          }
        }, item.content), /*#__PURE__*/React.createElement("ul", {
          className: styles.targetingList
        }, children));
      }) : null;
      return /*#__PURE__*/React.createElement("div", null, targeting);
    }
  }]);

  return AdDetailTargeting;
}(Component)) || _class);
export default AdDetailTargeting;